/**
 * Simple plugin to print out all kinds of application information on console
 * - $getMetaData: show meta data of application
 */
export default {
  install(Vue) {
    const metaData = {
      appVersion: process.env.VUE_APP_VERSION,
      gitHash: process.env.VUE_APP_GIT,
      deps: process.env.VUE_APP_DEPS
    };

    Vue.prototype.$getMetaData = () => metaData;

    function getCactusData() {
      const style = ['color: white', 'background: green', 'font-size: 14px', 'padding: 2px'].join(
        ';'
      );

      console.info(`%c Version: ${metaData.appVersion}`, style);
      console.info(`%c Commit: ${metaData.gitHash}`, style);
      console.info(`%c Dependencies: `, style);
      //console.table(JSON.parse(metaData.deps));
    }

    window.getCactusData = getCactusData;
  }
};
